import { AxiosError } from "axios";
import { api } from "../../utils/client";
import { Review } from "../../types";
import { ReviewFormData } from "./types";
import { REVIEW_NOTE_NAMES } from "./utils";

export type ReviewSubmitFailure = {
  errors: string[];
  review?: Partial<Review>;
};

const DEFAULT_ERROR = "Une erreur est survenue, merci de réessayer.";

export const buildReviewParams = (review: ReviewFormData) => ({
  ...REVIEW_NOTE_NAMES.reduce(
    (acc, name) => {
      acc[name] = review[name];
      return acc;
    },
    {} as Record<string, number | undefined>,
  ),
  license_plate: review.license_plate,
  comment: review.comment,
  tops: review.tops,
  flops: review.flops,
  email: review.email,
  user_id: review.user_id,
});

export const submitReview = async (
  review: ReviewFormData,
  url = "/reviews",
): Promise<Review> => {
  try {
    const response = await api.post<{ review: Review }>(
      url,
      { review: buildReviewParams(review) },
      // Le serveur interroge l'API plaque pendant la création : le timeout par
      // défaut (10s) du client couperait l'appel alors que l'avis est créé.
      { timeout: 30000 },
    );
    return response.data.review;
  } catch (error) {
    const data = (error as AxiosError<ReviewSubmitFailure>).response?.data;
    throw {
      errors: data?.errors?.length ? data.errors : [DEFAULT_ERROR],
      review: data?.review,
    } satisfies ReviewSubmitFailure;
  }
};
